<div *ngIf="!IsPageLoaded; else populated;">
  <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/loader/loading-page.gif" style="padding: 10% 35%;">
</div>
<ng-template #populated>
  <div class="cManikPopupWidth">
    <div class="main-content">
      <div class="cPopupContainer">
        <div [ngClass]="{'cPopupSidebar': ShowSectionList,'cPopupSidebarNarrow': !ShowSectionList}">
          <div class="cPopupMenu1">
            <ul class="nav">
              <li data-toggle="collapse" class="collapsed">
                <a matTooltip="Page settings" [matTooltipPosition]="'right'" (click)="PopulateMenu2('Page')">
                  <i class="material-icons">menu</i>
                </a>
              </li>
              <li data-toggle="collapse" class="collapsed" *ngIf="MicroPageID">
                <a matTooltip="Paragraph settings" [matTooltipPosition]="'right'" (click)="PopulateMenu2('Section')">
                  <i class="material-icons">view_module</i>
                </a>
              </li>
            </ul>
            <ul class="nav cPopupLowerUL">
              <li data-toggle="collapse" class="collapsed">
                <a matTooltip="Background" [matTooltipPosition]="'right'" (click)="PopulateMenu2('Background')">
                  <i class="material-icons">pages</i>
                </a>
              </li>
            </ul>
          </div>
          <div [ngClass]="{'cPopupMenu2': ShowSectionList, 'cPopupMenu2Hidden': !ShowSectionList}">
            <ul class="sub-menu" *ngIf="ShowSectionList">
              <li *ngFor="let t of SectionData" class="nav-link">
                <a (click)="OnSelectSection(t)" class="nav-link">
                  <i class="{{t.ContentIconText}}"></i>
                  {{t.ContentHeader}}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div [ngClass]="{'cPopupMainPanel': ShowSectionList, 'cPopupMainPanelExpanded': !ShowSectionList}">
          <div class="cPopupWorkSpace" [hidden]="!ShowPageSettings">
            <form [formGroup]="PageForm">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <image-handler [ImageData]="ImageData"></image-handler>
                  </div>
                  <div class="col-md-6">
                    <div class="cDefault">
                      <h5>Header</h5>
                      <input type="text" formControlName="PageHeaderText">
                    </div>
                    <div class="cDefault">
                      <h5>Slogan</h5>
                      <input type="text" formControlName="PageSloganText">
                    </div>
                    <div class="cDefault">
                      <h5>Description</h5>
                      <textarea formControlName="PageDescription"></textarea>
                    </div>
                    <div class="cDefault">
                      <h5>Show action button?</h5>
                      <mat-radio-group formControlName="ShowActionButton">
                        <mat-radio-button value="Y">
                          Yes
                        </mat-radio-button>
                        <mat-radio-button value="N">
                          No
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                    <div class="cDefault" *ngIf="GetPageForm.ShowActionButton.value === 'Y'">
                      <h5>Action text</h5>
                      <input type="text" formControlName="ActionText">
                    </div>
                    <div class="cDefault" *ngIf="GetPageForm.ShowActionButton.value === 'Y'">
                      <h5>Action URL</h5>
                      <input type="text" formControlName="ActionURL">
                    </div>
                    <input type="hidden" formControlName="ReservedIdentifier">
                    <input type="hidden" formControlName="BusinessID">
                    <input type="hidden" formControlName="IsActive">
                    <input type="hidden" formControlName="SectionTypeID">
                  </div>
                </div>
              </div>
            </form>
            <div class="cPopupAction">
              <button class="cButtonPopupSubmit" (click)="SubmitPageSettings($event)"></button>
            </div>
          </div>
          <div class="cPopupWorkSpace" [hidden]="!ShowSectionList">
            <div [hidden]="!SectionNotSelected">Please select a paragraph</div>
            <div [hidden]="SectionNotSelected">
              <form [formGroup]="SectionForm">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <image-handler [ImageData]="ImageData"></image-handler>
                    </div>
                    <div class="col-md-6">
                      <div class="cDefault">
                        <h5>Paragraph header</h5>
                        <input type="text" formControlName="ContentHeader">
                      </div>
                      <div class="cDefault">
                        <h5>Paragraph sub-header</h5>
                        <input type="text" formControlName="ContentSubHeader">
                      </div>
                      <div class="cDefault">
                        <h5>Paragraph text</h5>
                        <textarea formControlName="ContentText"></textarea>
                      </div>
                      <div class="cDefault">
                        <h5>Show action button?</h5>
                        <mat-radio-group formControlName="ShowActionButton">
                          <mat-radio-button value="Y">Yes</mat-radio-button>
                          <mat-radio-button checked value="N"> No </mat-radio-button>
                        </mat-radio-group>
                      </div>
                      <div class="cDefault" *ngIf="GetSectionForm.ShowActionButton.value === 'Y'">
                        <h5>Action text</h5>
                        <input type="text" formControlName="ActionText">
                      </div>
                      <div class="cDefault" *ngIf="GetSectionForm.ShowActionButton.value === 'Y'">
                        <h5>Action URL</h5>
                        <input type="text" formControlName="ActionURL">
                      </div>
                      <div class="cDefault">
                        <h5>Show buy button?</h5>
                        <mat-radio-group formControlName="ShowBuyButton">
                          <mat-radio-button value="Y">
                            Yes
                          </mat-radio-button>
                          <mat-radio-button value="N">
                            No
                          </mat-radio-button>
                        </mat-radio-group>
                      </div>
                      <div class="cDefault" *ngIf="GetSectionForm.ShowBuyButton.value === 'Y'">
                        <h5>Buy text</h5>
                        <input type="text" formControlName="BuyText">
                      </div>
                      <div class="cDefault" *ngIf="GetSectionForm.ShowBuyButton.value === 'Y'">
                        <h5>Buy URL</h5>
                        <input type="text" formControlName="BuyURL">
                      </div>
                      <div class="cDefault" *ngIf="GetSectionForm.ShowBuyButton.value === 'Y'">
                        <h5>Price tag</h5>
                        <input type="text" formControlName="PriceTag">
                      </div>
                      <div class="cDefault">
                        <h5>Display order</h5>
                        <input type="text" formControlName="DisplayOrder" (keypress)="manikInteger($event)">
                      </div>
                      <div class="cDefault">
                        <h5>Style class</h5>
                        <input type="text" formControlName="StyleClass">
                      </div>
                      <div class="cDefault">
                        <h5>Icon</h5>
                        <input type="text" formControlName="ContentIconText">
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div class="cPopupAction">
                <button class="cButtonPopupSubmit" (click)="SubmitSectionSettings($event)"></button>
              </div>
            </div>
          </div>
          <div class="cPopupWorkSpace cBackgroundMediaSettings" [hidden]="!ShowBackgroundSettings">
            Background settings
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>